// AdSlot.js — a responsive AdSense unit in a reviewed, policy-safe position
// (never next to the grid, where accidental clicks happen). Renders nothing
// until that position's slot id is set at build time, e.g.
// REACT_APP_ADSENSE_SLOT_HOME=1234567890 npm run build. Slot ids come from
// AdSense (Ads > By ad unit) once the site is approved.

import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const CLIENT = "ca-pub-8087074796918095";
// CRA only inlines literal process.env.REACT_APP_* references, hence the map.
const SLOTS = {
  home: process.env.REACT_APP_ADSENSE_SLOT_HOME,
  records: process.env.REACT_APP_ADSENSE_SLOT_RECORDS,
  article: process.env.REACT_APP_ADSENSE_SLOT_ARTICLE,
};

export default function AdSlot({ position }) {
  const slot = SLOTS[position];
  useEffect(() => {
    if (!slot) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Ad blockers throw here; the page is fine without the ad.
    }
  }, [slot]);
  if (!slot) return null;
  return (
    <Box component="aside" aria-label="Advertisement" sx={{ my: 2 }}>
      <Typography sx={{ color: "#6d7080", fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", mb: 0.5 }}>
        Advertisement
      </Typography>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </Box>
  );
}
